<template>
  <a-modal :open="open" @cancel="closeForm" class="modal-no-padding">
    <div class="modal-no-padding__header">
      <h2>Приглашение сотрудника: ({{ userText }})</h2>
    </div>
    <a-divider style="margin: 16px 0" />
    <div class="modal-no-padding__body">
      <p class="modal-text">
        Отправить на почту письмо с данными для входа в личный кабинет сотрудника.
      </p>
    </div>

    <template #footer>
      <a-divider style="margin: 16px 0" />
      <div class="modal-no-padding__footer">
        <div class="action-buttons">
          <a-row justify="end" :gutter="8">
            <a-col>
              <a-button class="secondary-button" @click="closeForm">Отменить</a-button>
            </a-col>
            <a-col>
              <a-button class="primary-button" :loading="modalActionLoading" @click="handleInviteNotifications">Отправить</a-button>
            </a-col>
          </a-row>
        </div>
      </div>
    </template>
  </a-modal>
</template>

<script>
import {message} from "ant-design-vue";
import {useStore} from "vuex";
import {ref} from "@vue/runtime-core";
import {computed} from "@vue/reactivity";

export default {
  props: {
    open: Boolean,
    currentActionUser: Object,
    selectedUsers: Array,
  },
  emits: ['submitted', 'close'],
  setup(props, context) {
    const store = useStore();
    const modalActionLoading = ref(false);
    const groupToCopyIn = ref();

    const handleInviteNotifications = () => {
      modalActionLoading.value = true;

      let users = [];
      if (props.currentActionUser?.id) {
        users.push(props.currentActionUser.id);
      } else {
        users = props.selectedUsers;
      }

      store.dispatch('users/sendStaffNotification', {users: users}).then(() => {
        message.success('Приглашения отправлены');
        context.emit('submitted')
      }).finally(() => {
        modalActionLoading.value = false;
      });
    }

    const closeForm = () => {
      context.emit('close');
    }

    const userText = computed(() => {
      return props.currentActionUser?.name ||
          props.currentActionUser?.first_name ||
          props.currentActionUser?.last_name ||
          props.selectedUsers.length
    });

    return {
      groupToCopyIn,
      modalActionLoading,
      closeForm,
      handleInviteNotifications,
      userText
    }
  }
}
</script>

<style scoped lang="scss">

</style>